<template>
  <div class="card border-1 bg-transparent text-white">

      <div class="row pt-3">
        <div class="col-9">
          <div class="card-body text-left">
            <h5 class="card-title">{{ data }}</h5>
          </div>
          <div class="card-footer border-0 bg-transparent text-muted text-left">
            {{ title }}
          </div>
        </div>
        <div class="col-3">
          <div class="icon icon-box-success">
            <span class="material-icons icon-item">call_made</span>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
name: "cardData",
  props: {
    title: String,
    data: Number
  }
}
</script>

<style scoped>
  .card-title{
    font-size: 1.8rem;
    font-weight: bold;
    line-height: 1.2;
  }

  icon.icon-box-success {
    width: 40px;
    height: 37px;
    background: rgba(0, 210, 91, 0.11);
    border-radius: 7px;
    color: #00d25b;
  }
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon .icon-item {
    font-size: 20px;
  }
  .icon.icon-box-success {
    width: 40px;
    height: 37px;
    background: rgba(0, 210, 91, 0.11);
    border-radius: 7px;
    color: #00d25b;
  }
</style>